/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NonCadastralLvOwnershipDto } from './nonCadastralLvOwnershipDto.model';
import { NonCadastralParcel } from './nonCadastralParcel.model';
import { NonCadastralSource } from './nonCadastralSource.model';


export interface NonCadastralLvDto { 
    cadastreName?: string;
    distinctChar?: string;
    katuzeKod?: number;
    lv?: number;
    ownerships?: Array<NonCadastralLvOwnershipDto>;
    parcels?: Array<NonCadastralParcel>;
    source?: NonCadastralSource;
}
export namespace NonCadastralLvDto {
}


